import React from 'react';
import { PrimaryButtonLightBg } from 'apps/sigma2-ui/src/components/PrimaryButtonLightBg';
import { CircularProgress } from '@mui/material';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export interface ExportButtonProps {
  /**
   * Callback when the button is clicked
   */
  onClick: () => void;

  /**
   * Whether or not the button is disabled
   */
  disabled: boolean;

  /**
   * The number (if any) shown for the button in the parantheses
   * If the value is 0, then we do not show this
   */
  amount: number;

  /**
   * Whether to show the little spinner next to the button
   * This indicates that the button is in the process of exporting
   */
  exporting: boolean;
}

export const ExportButton = ({
  onClick,
  disabled,
  amount,
  exporting,
}: ExportButtonProps) => {
  const language = useLanguage();

  return (
    <PrimaryButtonLightBg
      onClick={onClick}
      disabled={disabled}
      translatedContent={language.exportButtonLabel({ amount })}
      icon={() => {
        if (exporting) {
          return (
            <CircularProgress
              size={16}
              thickness={4}
              color={'inherit'}
              className={disabled ? 'text-gray-400' : 'text-violet-100'}
            />
          );
        }

        return null;
      }}
    />
  );
};
